import { makeStyles } from '@material-ui/core/styles';

export default function ProdutoCardCss() {
    return makeStyles(theme => ({
        button: {
            height: "55px",
            borderRadius: "0 10px 10px 0"
        }
    }));
}